let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hnfnt")).then(() => parcelRequire('al4ZP'));